import { successAction } from '@utils/actions';
import { fetchShopReviews } from '@services/reviews.service';
import { errorAction } from '@shared/actions';
import { SHOP_DELIVERY_TYPE } from '@shared/constants';
import isEmptyObject from '@commons/utils/object/isEmptyObject';
import { getTotal, getReviewsCount } from './selectors';
import { FETCH_SHOP_REVIEWS, CLEAN_STATE } from './actionTypes';
import { PAGE_SIZE } from './constants';

export const cleanState = () => ({ type: CLEAN_STATE });

export const fetchReviews = ({ shopId, businessType, isPickup }) => async (
  dispatch,
  getState,
  axios,
) => {
  try {
    const state = getState();
    const total = getTotal(state);
    const reviewsCount = getReviewsCount(state);

    if (total !== 0 && reviewsCount !== 0 && total === reviewsCount) return;

    dispatch({ type: FETCH_SHOP_REVIEWS });

    const { success, data, error } = await fetchShopReviews({
      axios,
      shopId,
      businessType,
      max: PAGE_SIZE,
      occasion: isPickup
        ? SHOP_DELIVERY_TYPE.PICK_UP
        : SHOP_DELIVERY_TYPE.DELIVERY,
    });

    if (success) {
      if (!isEmptyObject(data)) {
        dispatch(
          successAction({
            type: FETCH_SHOP_REVIEWS,
            payload: { total: data.total, reviews: data.data },
          }),
        );
      }
    } else {
      dispatch(errorAction({ type: FETCH_SHOP_REVIEWS, error }));
    }
  } catch (error) {
    dispatch(errorAction({ type: FETCH_SHOP_REVIEWS, error }));
  }
};
